import { useState } from "react";
import { OpeningTimesDay } from "./types";
import OpeningTimesDayLine from "./opening-time-day-line";

export default function OpeningTimesTab() {
  const [editing, _setEditing] = useState<OpeningTimesDay | null>(null);

  const setEditing = (day: OpeningTimesDay) => (value: boolean) => {
    _setEditing(value ? day : null);
  };

  return (
    <div className="flex flex-col gap-6">
      <OpeningTimesDayLine
        day="monday"
        editing={editing === "monday"}
        setEditing={setEditing("monday")}
      />
      <OpeningTimesDayLine
        day="tuesday"
        editing={editing === "tuesday"}
        setEditing={setEditing("tuesday")}
      />
      <OpeningTimesDayLine
        day="wednesday"
        editing={editing === "wednesday"}
        setEditing={setEditing("wednesday")}
      />
      <OpeningTimesDayLine
        day="thursday"
        editing={editing === "thursday"}
        setEditing={setEditing("thursday")}
      />
      <OpeningTimesDayLine
        day="friday"
        editing={editing === "friday"}
        setEditing={setEditing("friday")}
      />
      <OpeningTimesDayLine
        day="saturday"
        editing={editing === "saturday"}
        setEditing={setEditing("saturday")}
      />
      <OpeningTimesDayLine
        day="sunday"
        editing={editing === "sunday"}
        setEditing={setEditing("sunday")}
      />
    </div>
  );
}
